import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import { Alert, Button, Grid, Link, Paper, Typography } from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { useState } from 'react';

import BusinessTaxSubMenu from '@/components/nav/BusinessTaxSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const BusinessStateFlorida = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Florida Business Tax Filing Requirements | TaxZerone"
          description="Learn Florida business tax requirements, forms, deadlines, extensions, and penalties. Stay compliant and file confidently with TaxZerone guidance."
          keywords=" "
          canonical="business-tax/state-filing/florida-tax-filing-requirements/"
          jsonLdPricing=""
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="1658"
          ogShareImg=""
        />
      }
    >
      <BusinessTaxSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/florida-business-tax-img.webp" />
                <source srcSet="/assets/images/florida-business-tax-img.png" />
                <img
                  src="/assets/images/florida-business-tax-img.png"
                  alt="Florida Business Tax Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                {' '}
                <span className="highlight-container">
                  <span className="highlight">Florida </span>
                </span>{' '}
                Business Tax Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Understand what your business needs to file in Florida. From
                corporate income taxes to sales and reemployment tax filings,
                stay on top of every requirement and deadline to avoid
                penalties.
              </Typography>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/florida-business-tax-img-sm.webp" />
                <source srcSet="/assets/images/florida-business-tax-img-sm.png" />
                <img
                  src="/assets/images/florida-business-tax-img-sm.png"
                  alt="Florida Business Tax Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 4,
              pt: 5,
              textAlign: 'center',
            }}
          >
            What are the Business Tax Forms in Florida?
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
            Florida requires different business entities to file specific state
            tax forms with the{' '}
            <span style={{ fontWeight: 600 }}>
              {' '}
              Florida Department of Revenue (DOR).
            </span>
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, textAlign: 'center' }}>
            Here’s a breakdown by business type:
          </Typography>

          <Grid container spacing={2} sx={{ mb: 5, justifyContent: 'center' }}>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/single-member-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/single-member-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/single-member-icon.png"
                    alt="Sole Proprietorship & Single-Member LLC"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Sole Proprietorship & <br /> Single-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.irs.gov/pub/irs-pdf/f1040.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Federal Form 1040
                        </Link>{' '}
                        –
                      </span>{' '}
                      U.S. Individual Income Tax Return
                    </li>

                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.irs.gov/pub/irs-prior/f1040sc--2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Schedule C
                        </Link>{' '}
                        -
                      </span>{' '}
                      Profit or Loss from Business (Sole Proprietorship)
                    </li>
                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://floridarevenue.com/Forms_library/current/rt6.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Form RT-6
                        </Link>{' '}
                        -
                      </span>{' '}
                      Employer’s Quarterly Report for Reemployment Tax (if
                      applicable)
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>{' '}
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/Partnership-income-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/Partnership-income-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/Partnership-income-icon.png"
                    alt="Partnership & Multi-Member LLC"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Partnership & Multi-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://floridarevenue.com/forms_library/current/f1065.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form F-1065
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Florida Partnership Information Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.irs.gov/pub/irs-pdf/f1065sk1.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Schedule K-1
                        </Link>{' '}
                        –
                      </span>{' '}
                      Partner’s Share of Income, Deductions, Credits, etc.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/c-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/c-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/c-corporation-icon.png"
                    alt="C Corporation"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    C Corporation
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        <Link
                          href="https://floridarevenue.com/Forms_library/current/f1120.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form F-1120
                        </Link>{' '}
                        –
                      </span>{' '}
                      Florida Corporate Income/Franchise Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://floridarevenue.com/Forms_library/current/f1120es.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form F-1120ES
                        </Link>{' '}
                      </span>{' '}
                      Florida Estimated Income/Franchise Tax
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://floridarevenue.com/Forms_library/current/f1120a.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form F-1120A
                        </Link>{' '}
                        -
                      </span>{' '}
                      Florida Corporate Short Form Income Tax Return
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/s-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/s-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/s-corporation-icon.png"
                    alt="Sales and Use Tax "
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Sales and Use Tax
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://floridarevenue.com/forms_library/current/dr15.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR-15
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Sales and Use Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://floridarevenue.com/Forms_library/current/dr15ez.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR-15EZ
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Sales and Use Tax Return (EZ Form)
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/business-tax-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/business-tax-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/business-tax-icon.png"
                    alt="Reemployment Tax"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Reemployment Tax
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://floridarevenue.com/Forms_library/current/rt6.pdf"
                          sx={{ color: '#0202ff' }}
                          target="_blank"
                        >
                          {' '}
                          Form RT-6
                        </Link>{' '}
                        –
                      </span>{' '}
                      Employer&apos;s Quarterly Report
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/property-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/property-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/property-icon.png"
                    alt="Additional Florida Business Tax Forms"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Additional Florida Business Tax Forms
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-3872.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR-225
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Documentary Stamp Tax Return for Registered
                      Taxpayers&apos; Unrecorded Documents
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://floridarevenue.com/Forms_library/current/rts6061.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form RTS-6061
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Independent Contractor Analysis
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ pt: 6, pb: 6, textAlign: 'center' }}>
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column' }}
          sx={{ pt: 2, pb: 2, justifyContent: 'center', mb: 2 }}
        >
          <Grid
            size={12}
            sx={{
              textAlign: { md: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'center', sm: 'center' },
                }}
              >
                What are the Deadlines for Business Tax Forms in Florida?
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: { lg: 18, md: 16, sm: 14, xs: 14 }, mb: 3 }}
              >
                Understand the key deadlines for filing Florida business taxes
                for all entity types:
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Corporations
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'left',
                  mb: 1,
                }}
              >
                Return due date:{' '}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 28, md: 26, sm: 22, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  1<sup>st</sup> day
                </Box>{' '}
                of 4th month
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'left',
                  mb: 1,
                }}
              >
                Payment due date:{' '}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 28, md: 26, sm: 22, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  1<sup>st</sup> day
                </Box>{' '}
                of 4th month
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(213, 189, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Stack
                spacing={2}
                direction={{ md: 'column', xs: 'column' }}
                justifyContent="center"
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    textAlign: 'center',
                  }}
                >
                  Sales and Use Tax
                </Typography>
                <Box
                  sx={{
                    textAlign: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                  }}
                >
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { lg: 20, md: 20, sm: 18, xs: 16 },
                        fontWeight: 500,
                        textAlign: 'left',
                        mb: 1,
                      }}
                    >
                      Return due date:{' '}
                      <Box
                        component="span"
                        sx={{
                          fontWeight: 700,
                          fontSize: { lg: 28, md: 26, sm: 22, xs: 20 },
                          background:
                            'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                          backgroundClip: 'text',
                          color: 'transparent',
                        }}
                      >
                        1<sup>st</sup> day
                      </Box>{' '}
                      <Box
                        component="span"
                        sx={{
                          fontWeight: 400,
                          fontSize: 16,
                        }}
                      >
                        {' '}
                        of the month following the collection month{' '}
                      </Box>
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { lg: 20, md: 20, sm: 18, xs: 16 },
                        fontWeight: 500,
                        textAlign: 'left',
                        mb: 1,
                      }}
                    >
                      Late after:{' '}
                      <Box
                        component="span"
                        sx={{
                          fontWeight: 700,
                          fontSize: { lg: 28, md: 26, sm: 22, xs: 20 },
                          background:
                            'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                          backgroundClip: 'text',
                          color: 'transparent',
                        }}
                      >
                        20<sup>th</sup> day
                      </Box>{' '}
                      of the month
                    </Typography>
                  </Box>
                </Box>
              </Stack>
            </Paper>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Reemployment Tax
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'left',
                  mb: 1,
                }}
              >
                Return due date:{' '}
                <Box component="span" sx={{ fontWeight: 400, fontSize: 16 }}>
                  Last day of the month following each quarter
                </Box>
              </Typography>
              <Box
                component="ul"
                sx={{ mb: 0, textAlign: 'left', '& li': { mb: 1.2 } }}
              >
                <li>
                  {' '}
                  <span style={{ fontWeight: 600 }}> Quarter 1:</span> April
                  30{' '}
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}> Quarter 2:</span> July
                  31{' '}
                </li>
                <li>
                  {' '}
                  <span style={{ fontWeight: 600 }}> Quarter 3:</span> October
                  31{' '}
                </li>
                <li>
                  {' '}
                  <span style={{ fontWeight: 600 }}> Quarter 4:</span> January
                  31{' '}
                </li>
              </Box>
            </Paper>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Tangible Personal Property Tax
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'center',
                }}
              >
                Return due date:
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                }}
              >
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  April 1
                </Box>
                <br />
                each year
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Alert
              severity="info"
              id="who"
              icon={false}
              sx={{ mb: 4, borderLeft: '3px solid #0288d1', textAlign: 'left' }}
            >
              <span style={{ fontWeight: 600 }}> Important Reminder:</span>
              <br /> An extension gives you extra time to{' '}
              <span style={{ fontWeight: 600 }}> file,</span> not to{' '}
              <span style={{ fontWeight: 600 }}>pay</span>. All taxes owed must
              be paid by the original due date to avoid penalties and interest.
            </Alert>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            direction={{ md: 'row', xs: 'column-reverse' }}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  What Business Extension Forms are required in Florida?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 0, fontSize: 20, fontWeight: 600 }}
                >
                  Business Type
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    mb: 3,
                    mr: 2,
                    ml: -3,
                    listStyleType: 'none',
                    '& li': { mb: 1.5 },
                  }}
                >
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Corporations
                      <Link
                        href="https://floridarevenue.com/Forms_library/current/f7004.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form F-7004
                      </Link>
                    </Box>
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      All Business Entities{' '}
                      <Link
                        href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        Form 7004
                      </Link>{' '}
                      <span style={{ fontWeight: 600 }}>(Federal) </span>
                    </Box>{' '}
                  </li>
                </Box>
                <Box
                  sx={{
                    maxWidth: 350,
                    mb: 3,
                    p: 2,
                    border: '5px solid transparent',
                    borderRadius: 3,
                    background:
                      'linear-gradient(#fcf6bd) padding-box, repeating-linear-gradient(-45deg, #C8102E 0, #C8102E 12.5%, #ffffff 0, #ffffff 25%, #3492b8 0, #3492b8 37.5%, #ffffff 0, #ffffff 50%) 0 / 5em 5em',
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: 700, mb: 0.8 }}>
                    {' '}
                    <MailOutlineOutlinedIcon
                      sx={{
                        position: 'relative',
                        ml: 0,
                        mr: 0.5,
                        mb: -1,
                        fontSize: 28,
                      }}
                    />{' '}
                    Mail Florida Form F-7004 to:
                  </Typography>
                  <Box
                    component="div"
                    sx={{ textAlign: 'left', fontSize: '15px important' }}
                  >
                    <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Florida Department of Revenue,
                      </span>{' '}
                      <br />
                      5050 W Tennessee St, <br />
                      Tallahassee, FL 32399-0135.
                    </Typography>
                  </Box>
                </Box>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  Electronic Payment Option
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Florida business tax payments can also be made online using
                  the{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Florida Department of Revenue’s e-Services portal:
                  </span>{' '}
                </Typography>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{ mb: 0, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <b>Note: </b> You can also{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    filing Form 7004
                  </Link>{' '}
                  through TaxZerone to request your federal business tax
                  extension easily and securely.
                </Alert>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              {/* <Link href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"> */}
              <Box
              // sx={{
              //   '&:hover': {
              //     transform: 'scale(1.02)',
              //   },
              //   '& .img-responsive:hover': {
              //     boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              //   },
              //   transition: 'transform 0.3s ease-in-out',
              // }}
              >
                <picture>
                  <source srcSet="/assets/images/florida-extension-img.webp" />
                  <source srcSet="/assets/images/florida-extension-img.png" />
                  <img
                    src="/assets/images/florida-extension-img.png"
                    alt="What are the Extended due dates for the Business Tax Forms in Florida?"
                    className="img-responsive"
                    loading="lazy"
                    width={500}
                    height={500}
                    style={{ borderRadius: 24 }}
                  />
                </picture>
              </Box>
              {/* </Link> */}
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ my: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive" textAlign="center" mb={3}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                What are the Extended due dates for the Business Tax
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                Forms in Florida?
              </Typography>
              {/* <Typography variant="body1" sx={{ mb: 3, fontSize: 18 }}>
                Understand the key{' '}
                <span style={{ fontWeight: 600 }}> extended deadlines</span> for
                filing Connecticut business taxes for all entity types:
              </Typography> */}
              <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Corporations (Form F-1120)
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        6-month
                      </Box>
                      <br />
                      extension
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 3,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Sales and Use Tax <br /> (Form DR-15)
                    </Typography>

                    <Typography variant="body1">
                      No extension available; must be filed monthly
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Reemployment Tax <br />
                      (Form RT-6)
                    </Typography>

                    <Typography variant="body1">
                      No extension available; must be filed quarterly
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Tangible Personal Property Tax <br /> (Form DR-405)
                    </Typography>

                    <Typography variant="body1">
                      Extension requests may be approved by county property
                      appraisers if filed by April 1
                    </Typography>
                  </Paper>{' '}
                </Stack>
              </Box>
              <Alert
                severity="warning"
                icon={false}
                sx={{
                  mb: 0,
                  mt: 4,
                  textAlign: 'left',
                  borderLeft: '3px solid rgb(102, 60, 0)',
                }}
              >
                <b>Note: </b> If the due date falls on a weekend or legal
                holiday, the return is considered timely if filed on the next
                business day.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          mb: 5,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container
          maxWidth="xl"
          sx={{
            mb: 5,
            '& .card__content': {
              animation: 'scale linear forwards',
              animationTimeline: 'view()',
              animationRange: '85vh 100vh',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 615, xs: 695 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(210, 186, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Stack
              spacing={2}
              direction={{ md: 'row', xs: 'column' }}
              justifyContent="center"
              alignItems="center"
            >
              <Box
                sx={{
                  textAlign: 'left',
                  alignItems: 'left',

                  justifyContent: 'left',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                  }}
                >
                  Florida Business Tax Extension Filing Requirements
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  To qualify for a business tax extension in Florida, your
                  business must:
                </Typography>
                <Box sx={{ maxWidth: 'auto', textAlign: 'left' }}>
                  <Box
                    component="ul"
                    sx={{
                      mb: 0,
                      mr: 2,
                      listStyleType: 'none',
                      '& li': { mb: 2, fontSize: { md: 17, sm: 16, xs: 14 } },
                    }}
                  >
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          File or pay by the original due date
                        </span>{' '}
                        to avoid penalties and interest.
                      </Box>
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Submit the correct extension form
                        </span>{' '}
                        based on your business entity type (Form{' '}
                        <span style={{ fontWeight: 600 }}> F-7004</span> –
                        Florida Tentative Income/Franchise Tax Return and
                        Application for Extension of Time to File).
                      </Box>{' '}
                    </li>

                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Estimate and pay any taxes owed —
                        </span>{' '}
                        extensions apply only to filing, not to payments.
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Meet the 6-month extension period,
                        </span>{' '}
                        typically extending your due date up to{' '}
                        <span style={{ fontWeight: 600 }}> October 1</span> (for
                        calendar-year filers).
                      </Box>{' '}
                    </li>

                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Keep payment confirmations and acknowledgment receipts
                        </span>
                        from the Florida Department of Revenue (DOR) for
                        compliance purposes.
                      </Box>{' '}
                    </li>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Box sx={{ Height: 450 }}>
                  <picture>
                    <source
                      srcSet="/assets/images/florida-state-img.webp"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <source
                      srcSet="/assets/images/florida-state-img.png"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <img
                      src="/assets/images/florida-state-img.png"
                      loading="lazy"
                      alt="business tax extension in Florida"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                  </picture>
                </Box>
              </Box>
            </Stack>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 615, xs: 695 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(244, 237, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ maxWidth: 'container' }}
            >
              <Grid size={{ xs: 12, sm: 6, md: 12 }}>
                <Box
                  component="div"
                  sx={{
                    mb: 3,
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 1,
                    }}
                  >
                    Florida Business Tax Rates
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 1,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 400,
                      textAlign: 'center',
                    }}
                  >
                    Business tax rates vary depending on your entity type:
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    C Corporation
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    5.5%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    of Florida net income
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    S Corporation
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    Exempt
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    from state corporate income tax in most cases
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    LLCs
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    Exempt
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    from state income tax.
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Partnerships (LP & LLPs)
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    Exempt
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    from state income tax
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Sales & Use Tax
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    6.0%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    local surtaxes may apply
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 5, md: 3, lg: 3 },
            //   borderRadius: { xs: 0, md: 4 },
            //   mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          // className="gradient-bg"
        >
          <Grid
            container
            spacing={2}
            direction={{ sm: 'row', xs: 'column-reverse' }}
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'center',
                  }}
                >
                  Estimated Tax Payments for Florida Businesses
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 18, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  Businesses in Florida must make estimated tax payments if they
                  expect to owe{' '}
                  <span style={{ fontWeight: 600 }}>more than $2,500 </span>
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>
                  in Florida corporate income or franchise tax for the year.
                  These prepayments help avoid underpayment penalties and
                  interest
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Payment Deadlines
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 2, fontWeight: 600, textAlign: 'center' }}
                >
                  For Tax Years Ending June 30
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      1<sup>st</sup> payment
                    </Typography>

                    <Typography variant="body1">
                      Last day of 4<sup>th</sup> month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      2<sup>nd</sup> payment
                    </Typography>

                    <Typography variant="body1">
                      Last day of 6<sup>th</sup> month
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      3<sup>rd</sup> Payment
                    </Typography>

                    <Typography variant="body1">
                      Last day of 9<sup>th</sup> month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      4<sup>th</sup> Payment
                    </Typography>

                    <Typography variant="body1">
                      (Last day of the tax year )
                    </Typography>
                  </Paper>
                </Stack>
                <Typography
                  variant="body1"
                  sx={{ mt: 2, fontWeight: 600, textAlign: 'center' }}
                >
                  For Tax Years Not Ending June 30{' '}
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      1<sup>st</sup> payment
                    </Typography>

                    <Typography variant="body1">
                      Last day of 5<sup>th</sup> month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      2<sup>nd</sup> payment
                    </Typography>

                    <Typography variant="body1">
                      Last day of 6<sup>th</sup> month
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      3<sup>rd</sup> Payment
                    </Typography>

                    <Typography variant="body1">
                      Last day of 9<sup>th</sup> month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      4<sup>th</sup> Payment
                    </Typography>

                    <Typography variant="body1">
                      (Last day of the tax year )
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Who should pay
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      C Corporations
                    </Typography>
                    <Typography variant="body1">
                      If expected tax liability exceeds $2,500, payments must be
                      made using Form F-1120ES.
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      S Corporations
                    </Typography>
                    <Typography variant="body1">
                      Generally, exempt unless subject to federal income tax.
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      LLCs, Partnerships, and Sole Proprietors
                    </Typography>
                    <Typography variant="body1">
                      Do not pay Florida corporate estimated tax unless
                      classified as a corporation for tax purposes.
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid
              size={12}
              sx={{
                mt: 2,
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box
                component="div"
                sx={{
                  backgroundColor: '#f5efff',
                  borderLeft: '5px solid #45247e',
                  p: 2,
                  mb: 4,
                  borderRadius: 2,
                  textAlign: 'left',
                }}
              >
                <Typography variant="body1" sx={{ fontSize: 14, mt: 0 }}>
                  <span style={{ fontWeight: 600 }}> Missed Payments:</span>{' '}
                  Failure to make timely estimated payments may result in
                  penalties and interest as per{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Rule 12C-1.034, Florida Administrative Code.
                  </span>{' '}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pt: 8,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ pt: 2, mb: 5 }}>
          <Grid container spacing={2} justifyContent="center">
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mt: 0,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Penalties and Interest for Businesses in Florida
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  fontSize: { md: 18, sm: 16, xs: 16 },
                  textAlign: 'center',
                }}
              >
                If your business fails to file or pay Florida taxes by the due
                date, the Department of Revenue
                <Hidden smDown>
                  {' '}
                  <br />{' '}
                </Hidden>{' '}
                {'  '}
                imposes penalties and interest — even if you’ve filed an
                extension.
              </Typography>

              <Typography
                variant="h4"
                sx={{
                  mb: 2,
                  fontWeight: 600,
                  textAlign: 'center',
                  fontSize: 20,
                }}
              >
                Penalties{' '}
              </Typography>
              <Stack
                spacing={2}
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="center"
                sx={{ mb: 2 }}
              >
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Late Filing / Payment Penalty
                    </Typography>
                    <Typography variant="body1">
                      A penalty of{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        10% of the unpaid tax due
                      </span>{' '}
                      is assessed for each month, or part of a month, that the
                      return or payment is late — up to a{' '}
                      <span style={{ fontWeight: 600 }}>maximum of 50%</span> of
                      the total tax due.{' '}
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Minimum Penalty
                    </Typography>
                    <Typography variant="body1">
                      If{' '}
                      <span style={{ fontWeight: 600 }}>
                        no tax is due, a $50 minimum penalty per month
                      </span>{' '}
                      applies, up to{' '}
                      <span style={{ fontWeight: 600 }}>$300 total</span> for
                      late returns.
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Underpayment of Tentative Tax
                    </Typography>
                    <Typography variant="body1">
                      If your business underpays the tentative tax during an
                      extension period, it may{' '}
                      <span style={{ fontWeight: 600 }}>
                        void the extension
                      </span>{' '}
                      and trigger the standard late filing penalty. Smaller
                      underpayments may incur a 12% annual penalty.
                    </Typography>
                  </Paper>
                </Box>
              </Stack>
              <Stack
                spacing={2}
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="center"
                sx={{ mb: 3 }}
              >
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Electronic Filing / Payment Non-Compliance
                    </Typography>
                    <Typography variant="body1">
                      Businesses required to file or pay electronically may face
                      a{' '}
                      <span style={{ fontWeight: 600 }}>
                        $10 penalty per instance
                      </span>{' '}
                      for non-compliance.
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Fraudulent Return
                    </Typography>
                    <Typography variant="body1">
                      Fraudulent Return Filing a fraudulent return results in a
                      <span style={{ fontWeight: 600 }}> 100% penalty</span> on
                      the tax deficiency amount.
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Administrative Collection Fee
                    </Typography>
                    <Typography variant="body1">
                      If a tax debt remains unpaid{' '}
                      <span style={{ fontWeight: 600 }}> after 90 days,</span> a
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        10% administrative collection fee
                      </span>{' '}
                      may be added to the outstanding balance.
                    </Typography>
                  </Paper>
                </Box>
              </Stack>
              <Typography
                variant="h4"
                sx={{
                  mb: 2,
                  fontWeight: 600,
                  textAlign: 'center',
                  fontSize: 20,
                }}
              >
                Interest
              </Typography>
              <Stack
                spacing={2}
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="center"
                sx={{ mb: 2 }}
              >
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Floating Rate
                    </Typography>
                    <Typography variant="body1">
                      Florida applies a{' '}
                      <span style={{ fontWeight: 600 }}>
                        floating interest rate
                      </span>{' '}
                      to all unpaid or underpaid business taxes.
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Rate Updates
                    </Typography>
                    <Typography variant="body1">
                      The rate is updated{' '}
                      <span style={{ fontWeight: 600 }}>semi-annually,</span>{' '}
                      based on changes in the{' '}
                      <span style={{ fontWeight: 600 }}>
                        adjusted prime lending rate.
                      </span>{' '}
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Current Rate
                    </Typography>
                    <Typography variant="body1">
                      For the period{' '}
                      <span style={{ fontWeight: 600 }}>
                        July 1, 2025 – December 31, 2025,
                      </span>{' '}
                      the{' '}
                      <span style={{ fontWeight: 600 }}>
                        annual interest rate is 12%.
                      </span>
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Accrual
                    </Typography>
                    <Typography variant="body1">
                      Interest{' '}
                      <span style={{ fontWeight: 600 }}>accrues daily</span>{' '}
                      from the original due date until the full payment is
                      received.
                    </Typography>
                  </Paper>
                </Box>
              </Stack>
              <Typography
                variant="h4"
                sx={{
                  mt: 3,
                  mb: 1,
                  fontWeight: 600,
                  textAlign: 'left',
                  fontSize: '20px !important',
                }}
              >
                Penalty Waivers
              </Typography>
              <Typography variant="body1">
                The Florida Department of Revenue may{' '}
                <span style={{ fontWeight: 600 }}> waive penalties</span> if
                there is{' '}
                <span style={{ fontWeight: 600 }}>reasonable cause,</span> such
                as:
              </Typography>
              <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                <li>Serious illness or death </li>
                <li>Natural disasters or unavoidable circumstances </li>
              </Box>
              <Typography variant="body1" sx={{ mb: 3 }}>
                However, penalties are{' '}
                <span style={{ fontWeight: 600 }}>
                  not typically waived for financial hardship.
                </span>
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/state-help-img.webp" />
                  <source srcSet="/assets/images/state-help-img.png" />
                  <img
                    src="/assets/images/state-help-img.png"
                    alt="How TaxZerone can Help You?"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  How TaxZerone can Help You?
                </Typography>

                <Typography variant="body1" sx={{ mt: 2, mb: 0 }}>
                  TaxZerone supports federal filings and provides clear guidance
                  to help your business stay compliant with Florida state tax
                  requirements. From corporate income taxes to sales and
                  reemployment filings, TaxZerone simplifies the entire
                  process—helping you identify which Florida business tax forms
                  your entity needs, stay on top of deadlines, manage
                  extensions, and avoid penalties or interest. With TaxZerone,
                  you can file federal forms confidently while ensuring your
                  Florida state filings are accurate, timely, and fully
                  compliant year-round.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Stay compliant and Effortless with TaxZerone.
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          File your federal forms online and get guided support for
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>
          your Florida state requirements — all in one place.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=florida`}
          >
            E-file Now
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 5 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What are the main business tax forms required in Florida?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 0 }}>
                      The main business tax forms in Florida depend on your
                      business type.{' '}
                      <span style={{ fontWeight: 600 }}>
                        Sole proprietorships and single-member LLCs
                      </span>{' '}
                      file <span style={{ fontWeight: 600 }}>Form 1040</span>{' '}
                      with <span style={{ fontWeight: 600 }}>Schedule C</span>{' '}
                      and <span style={{ fontWeight: 600 }}>RT-6</span> if they
                      have employees.{' '}
                      <span style={{ fontWeight: 600 }}>
                        Partnerships and multi-member LLCs
                      </span>{' '}
                      file <span style={{ fontWeight: 600 }}>F-1065</span> with{' '}
                      <span style={{ fontWeight: 600 }}>
                        Schedule K-1. C Corporations
                      </span>{' '}
                      submit <span style={{ fontWeight: 600 }}>F-1120</span> and{' '}
                      <span style={{ fontWeight: 600 }}>F-1120ES</span> or
                      <span style={{ fontWeight: 600 }}> F-1120A.</span>{' '}
                      Businesses collecting sales tax use
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        DR-15/DR-15EZ,
                      </span>{' '}
                      and employers report reemployment tax with
                      <span style={{ fontWeight: 600 }}> RT-6.</span> Additional
                      forms like <span style={{ fontWeight: 600 }}>DR-225</span>{' '}
                      or <span style={{ fontWeight: 600 }}>RTS-6061</span> may
                      apply depending on the activities.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Can I get an extension for filing Florida business taxes?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 1 }}>
                      Yes, certain business taxes allow extensions:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}> Corporations:</span>{' '}
                        File Form F-7004 for a 6-month extension.
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Other entities:
                        </span>{' '}
                        <Link
                          href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Federal Form 7004
                        </Link>{' '}
                        can be used to request extensions.
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Sales & Use Tax and Reemployment Tax:
                        </span>{' '}
                        No extensions; must file on schedule.
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Which employers are subject to Reemployment Tax?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                      Employers must pay reemployment tax if they:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                      <li>
                        Pay{' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          $1,500 or more in total wages in any calendar quarter,
                        </span>{' '}
                        or
                      </li>
                      <li>
                        Have at least{' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          one employee working part of a day in 20 different
                          weeks
                        </span>{' '}
                        during a calendar year.
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What happens if I miss an estimated tax payment?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography sx={{ mt: 1 }}>
                      Late or missed payments can trigger{' '}
                      <span style={{ fontWeight: 600 }}>
                        underpayment penalties and interest
                      </span>{' '}
                      per Rule 12C-1.034, Florida Administrative Code.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default BusinessStateFlorida;
